import { UserServiceClient } from 'fitbeat.api-clients';
import {
  StrengthAssessmentStep,
  StrengthAssessmentSteps,
  UserProfile,
  WizardManager,
} from 'fitbeat.gym-core';
import React from 'react';
import { translate } from 'react-i18next';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { getApiConfig } from '../config/index';
import { IAppStore } from '../HomeWorkouts';
import theme from '../theme';
import { BaseModal } from '../ui';
import { toggleStrengthAssessmentModal } from '../ui/redux/uiActions';
import { AuthTokenBuilder } from '../utils';
import { Logger } from '../utils/Logger';
import { strengthAssessmentOpened } from './actions';
import { selectSteps, selectStepsAreLoading } from './selectors';
import { getStrengthAssessmentRouteConfig } from './strength-assessment-steps';
import { Wizard } from './Wizard';

interface IState {
  steps: StrengthAssessmentSteps;
}

interface IProps {
  wizardSteps: StrengthAssessmentSteps;
  t: any;
  isVisible: boolean;
  wizardStepsAreLoading: boolean;
  userProfile: UserProfile;
  currentStep: StrengthAssessmentStep | null;
  openStrengthAssessment(): void;
  closeModal(): void;
}

class StrengthAssessmentWizardComponent extends React.Component<
  IProps,
  IState
> {
  public componentDidUpdate(prevProps: IProps): void {
    const { openStrengthAssessment, isVisible } = this.props;
    if (!prevProps.isVisible && isVisible) {
      openStrengthAssessment();
    }
  }
  public render() {
    const {
      wizardSteps, t, isVisible, wizardStepsAreLoading, userProfile, closeModal,
    } = this.props;
    const shouldRenderWizard = wizardSteps.length > 0 && !wizardStepsAreLoading;
    const steps = getStrengthAssessmentRouteConfig(t, wizardSteps, userProfile);
    return (
      <BaseModal
        isModalVisible={isVisible}
        modalContainer={styles.modalContainer}
        bodyStyle={styles.modalBody}
        showHeader={false}
        hideCloseButton={true}
        closeModal={closeModal}
        useSafeAreaView={false}
      >
        {wizardStepsAreLoading && (
          <View style={styles.loadingContainer}>
            <ActivityIndicator
              size='small'
              color={theme.PRIMARY}
              animating={true}
            />
          </View>
        )}
        {shouldRenderWizard && (
          <Wizard
            steps={steps}
            wizardManager={new WizardManager()}
            isAnimationDisabled={false}
          />
        )}
      </BaseModal>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  const userServiceClient = new UserServiceClient(
    getApiConfig(),
    fetch,
    Logger.debug,
    new AuthTokenBuilder(),
  );
  return {
    openStrengthAssessment: () =>
      dispatch(strengthAssessmentOpened(userServiceClient)),
    closeModal: () => dispatch(toggleStrengthAssessmentModal(false)),
  };
};

const mapStateToProps = (state: IAppStore) => {
  return {
    wizardSteps: selectSteps(state),
    wizardStepsAreLoading: selectStepsAreLoading(state),
    isVisible: state.ui.strengthAssessmentModalVisible,
    currentStep: state.strengthAssessment.currentStep,
  };
};

export const StrengthAssessmentWizard = translate(['strengthAssessment'], {
  wait: true,
})(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(StrengthAssessmentWizardComponent),
);

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalBody: {
    flex: 1,
    padding: 0,
  },
});
